<template>
    <SettingCommonForAndroid ref="settingCommonForAndroid"
                                @notifyUpdate="onNotifyUpdate" />
    <div class="setting-footer-box d-flex ms-auto" style="height: 56px; margin-top: 16px;">
        <div class="d-flex flex-row ms-auto" style="height: 56px;">
            <button type="button"
                    class="btn-scv-blue btn-footer-size"
                    @click="onBtnApply">
                ＯＫ
            </button>
            <div style="width: 24px"></div>
            <button type="button"
                    class="btn-scv-white btn-footer-size"
                    @click="onBtnCancel">
                キャンセル
            </button>
            <div style="width: 16px"></div>
        </div>
    </div>
    <Loading ref="loading" :name="name" />
</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import SettingCommonForAndroid from '@/views/Mobile/Android/SettingCommonForAndroid.vue';
    import Loading from '@/components/Loading.vue';

    // C#から受け取るJSONデータ
    declare const androidPolicyJson: string;
    declare const completedSetPolicy: boolean;

    @Options({
        components: {
            SettingCommonForAndroid,
            Loading,
        },
        emits: [
            'notifyUpdate'
        ],
    })

    export default class AndroidPolicyView extends Vue {
        private intervalID = -1;
        private isDirty = false;        // 更新したかどうか
        private jsonDataModify = "";    // 共通コンポーネントから受け取る変更後のJSONデータ

        /**
         * マウント後の処理
         */
        public async mounted(): Promise<void> {
            // ローディング表示開始
            const refObj: any = this.$refs;
            refObj.loading.startLoading();

            // C#から情報が渡ってきたことを検知するためにポーリングする。
            this.intervalID = setInterval(this.onInterval, 100);
        }

        private onInterval(): void {
            if (false == completedSetPolicy) {
                return;
            }

            // タイマーを止める。
            clearInterval(this.intervalID);
            this.intervalID = -1;

            let json = JSON.stringify("");
            if (typeof androidPolicyJson !== 'undefined') {
                json = JSON.stringify(androidPolicyJson);
            }

            // 共通コンポーネントにJSON文字列をセット
            const refObj: any = this.$refs;
            refObj.settingCommonForAndroid.setPolicyJsonText(json);

            // ローディング表示終了
            refObj.loading.stopLoading();
        }

        /**
         * 設定変更通知
         */
        public onNotifyUpdate(_isDirty: boolean): void {
            this.isDirty = _isDirty;
            // WebView2へ設定変更通知
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window.chrome.webview.hostObjects.class.onNotifyUpdate(this.isDirty);
        }


        /**
         * @brief	ＯＫボタンを押下
         */
        private onBtnApply() {
            // 共通コンポーネントからJSON文字列を取得
            const refObj: any = this.$refs;
            
            // OKボタンチェック
            if (!refObj.settingCommonForAndroid.isApply()) {
                // メッセージは共通コンポーネント側が出します
                return;
            }
            
            this.jsonDataModify = refObj.settingCommonForAndroid.getPolicyJsonText();
            // console.log("★共通コンポーネントから返されたJSON文字列 : " + this.jsonDataModify);

            // WebView2へ適用通知
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window.chrome.webview.hostObjects.class.onApply(this.jsonDataModify);
        }

        /**
         * @brief	キャンセルボタンを押下
         */
        private onBtnCancel() {
            // WebView2へ適用通知
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window.chrome.webview.hostObjects.class.onCancel();
        }
    }
</script>

<style scoped>
    .scv-text-loading {
        font-size: 13px;
    }
</style>